var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDownload = function SvgIconDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1B",
    fillOpacity: 0.88,
    d: "M8.5 10.667 5.167 7.334l.933-.967L7.833 8.1V2.667h1.334V8.1L10.9 6.367l.933.967zm-4 2.667q-.55 0-.942-.392A1.28 1.28 0 0 1 3.167 12v-2H4.5v2h8v-2h1.333v2q0 .55-.391.942a1.28 1.28 0 0 1-.942.392z"
  })));
};
export default SvgIconDownload;